<template>
  <el-card>
    <div ref="chartdiv" style="height: 300px" />
  </el-card>
</template>

<script lang="ts">
import useResize from '@/hooks/useResize'

import {
  defineComponent,
  ref,
  shallowRef,
  onMounted,
  onBeforeUnmount,
  watch
} from 'vue'

import { am4core, am4charts } from '@/utils/async_chart_loader'

export default defineComponent({
  name: 'ReportPie',
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const { isDesktop } = useResize()
    const chartdiv = ref(null)
    const chartBox = shallowRef()

    const renderChart = () => {
      if (!props.data.length) {
        clearChart()
        return
      }
      clearChart()
      // @ts-ignore: Object is possibly 'null'.
      const chart = am4core.create(chartdiv.value, am4charts.PieChart)
      chart.hiddenState.properties.opacity = 0 // this creates initial fade-in
      chart.data = props.data.map((item: any) => {
        if (item.name === 'Other Networks') {
          item.name = 'Own deals'
        }
        return {
          name: item.name,
          impressions: item.impressions
        }
      })
      chart.responsive.enabled = true

      const series = chart.series.push(new am4charts.PieSeries())
      series.dataFields.value = 'impressions'
      // @ts-ignore: Object is possibly 'null'.
      series.dataFields.depthValue = 'impressions'
      series.dataFields.category = 'name'
      series.slices.template.stroke = am4core.color('#fff')
      series.slices.template.strokeWidth = 2
      series.slices.template.strokeOpacity = 1

      // This creates initial animation
      series.hiddenState.properties.opacity = 1
      series.hiddenState.properties.endAngle = -90
      series.hiddenState.properties.startAngle = -90

      chartBox.value = chart
    }

    const clearChart = () => {
      if (chartBox.value && !chartBox.value.isDisposed) {
        chartBox.value.dispose()
        chartBox.value = null
      }
    }

    onMounted(() => {
      renderChart()
    })

    onBeforeUnmount(() => {
      clearChart()
    })

    watch(
      () => props.data,
      () => renderChart()
    )

    return { isDesktop, chartdiv }
  }
})
</script>

<style lang="scss" scoped>
.el-card {
  padding: 0;
  margin-top: 10px;
}
:deep(svg) {
  font-size: 0.8em;
}
</style>
